module.exports = __webpack_public_path__ + "static/media/bg.fc395ab4.jpg";